export default "__VITE_ASSET__CFg16PR1__"